<template>
	<div class="search">
		<el-form :inline="true" :model="searchParams">
			<el-form-item
				v-for="(item, index) in searchList"
				:key="index"
				:class="right ? 'right clearfloat' : 'clearfloat'"
			>
				<!-- 输入框 -->
				<el-input
					size="mini"
					v-if="item.type == 'input'"
					v-model.trim="searchParams[item.prop]"
					:min="item.min"
					:max="item.max"
					:type="item.typeMethod"
					:placeholder="item.label"
					clearable
				></el-input>
				<!-- 选择 -->
				<el-select
					size="mini"
					v-if="item.type == 'select'"
					v-model="searchParams[item.prop]"
					:placeholder="item.label"
					:filterable="item.filterable"
					@change="(val) => handleChange(val, item)"
				>
					<el-option
						v-for="(option, key) in item.options"
						:key="key"
						:label="option.label"
						:value="option.value"
					></el-option>
				</el-select>
				<!-- 多级 -->
				<el-cascader
					size="mini"
					v-if="item.type == 'cascader'"
					v-model="searchParams[item.prop]"
					:placeholder="item.label"
					:options="item.options"
					clearable
					:Props="item.Props"
				></el-cascader>
				<!-- 年月日分秒 -->
				<el-date-picker
					size="mini"
					v-if="item.type == 'dateTime'"
					value-format="yyyy-MM-dd HH:mm:ss"
					v-model="searchParams[item.prop]"
					:placeholder="item.label"
					type="datetime"
				></el-date-picker>
				<!-- 年月日 -->
				<el-date-picker
					size="mini"
					v-if="item.type == 'date'"
					type="date"
					value-format="yyyy-MM-dd"
					v-model="searchParams[item.prop]"
					:placeholder="item.label"
				></el-date-picker>
				<!-- 日期间距 -->
				<el-date-picker
					size="mini"
					v-if="item.type == 'daterange'"
					type="daterange"
					value-format="yyyy-MM-dd HH:mm:ss"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					v-model="searchParams[item.prop]"
					:default-time="['00:00:00', '23:59:59']"
				></el-date-picker>
				<!-- 时间间距 -->
				<el-date-picker
					size="mini"
					v-if="item.type == 'datetimerange'"
					type="datetimerange"
					range-separator="至"
					:start-placeholder="
						item.startName ? item.startName : '开始时间'
					"
					:end-placeholder="item.endName ? item.endName : '结束时间'"
					v-model="searchParams[item.prop]"
				></el-date-picker>
				<!-- 带建议输入框 -->
				<el-autocomplete
					size="mini"
					v-if="item.type == 'autocomplete'"
					class="inline-input"
					v-model="searchParams[item.prop]"
					:fetch-suggestions="querySearch"
					:placeholder="item.label"
				></el-autocomplete>
			</el-form-item>
			<el-form-item :class="right ? 'right clearfloat' : 'clearfloat'">
				<el-button
					size="mini"
					type="primary"
					icon="el-icon-search"
					@click="submitForm(formName)"
				></el-button>
				<el-button plain size="mini" @click="resetForm(formName)">
					重置
				</el-button>
			</el-form-item>
			<el-form-item
				class="rBtn"
				v-if="isAdd"
				:class="right ? 'right clearfloat' : 'clearfloat'"
			>
				<el-button
					type="primary"
					size="mini"
					:disabled="btnDisable"
					@click="add('new')"
				>
					{{ buttonName }}
				</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	props: {
		searchList: {
			type: Array,
			default: () => {
				return [];
			},
		},
		right: {
			type: Boolean,
			default: false,
		},
		formName: {
			type: String,
			default: "",
		},
		searchParams: {
			type: Object,
			default: () => {
				return {};
			},
		},
		querySearch: {
			type: Function,
			default: () => {},
		},
		isAdd: {
			type: Boolean,
			default: false,
		},
		buttonName: {
			type: String,
			default: "",
		},
		btnDisable: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			searchDate: [],
		};
	},
	created() {},
	methods: {
		submitForm(formName) {
			this.$emit("submitForm", formName);
		},
		resetForm(formName) {
			this.$emit("resetForm", formName);
		},
		add() {
			this.$emit("add");
		},
		handleChange(val, item) {
			let para = {
				value: val,
				...item,
			};
			this.$emit("handleChange", para);
		},
	},
};
</script>

<style>
.search {
	margin: 0px;
}

.search .rBtn .el-form-item {
	float: right;
	padding-right: 5px;
}
</style>
